import * as React from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";

export default function LinearIndeterminate() {
  return (
    <Box
      sx={{
        width: "80%",
        height: "50vh",
        paddingLeft: "10%",
        paddingRight: "10%",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <CircularProgress color="secondary" />
    </Box>
  );
}
